import { gql, TypedDocumentNode } from "@apollo/client";

export type RecordingConsentAction = "ACKNOWLEDGED" | "DECLINED";
export type RecordingConsentSource =
  | "WEB"
  | "MOBILE"
  | "PET_PASS_VET";
export type RecordingConsentSurface =
  | "RECORDING"
  | "UPLOAD"
  | "APPEND"
  | "SCRIBEPHONE";

export interface RecordingConsentEvent {
  uuid: string;
  userEmail: string;
  action: RecordingConsentAction;
  consentText: string;
  consentTextVersion: string;
  source: RecordingConsentSource;
  surface: RecordingConsentSurface;
  noteUuid: string | null;
  createdAt: string;
}

export interface OrganizationRecordingConsentEventsData {
  organizationRecordingConsentEvents: {
    events: RecordingConsentEvent[];
    nextCursor: string | null;
  };
}

export interface OrganizationRecordingConsentEventsVariables {
  orgUuid: string;
  dateFrom?: string;
  dateTo?: string;
  cursor?: string;
  limit?: number;
}

const ORGANIZATION_RECORDING_CONSENT_EVENTS: TypedDocumentNode<
  OrganizationRecordingConsentEventsData,
  OrganizationRecordingConsentEventsVariables
> = gql`
  query OrganizationRecordingConsentEvents(
    $orgUuid: UUID!
    $dateFrom: DateTime
    $dateTo: DateTime
    $cursor: String
    $limit: Int
  ) {
    organizationRecordingConsentEvents(
      orgUuid: $orgUuid
      dateFrom: $dateFrom
      dateTo: $dateTo
      cursor: $cursor
      limit: $limit
    ) {
      events {
        uuid
        userEmail
        action
        consentText
        consentTextVersion
        source
        surface
        noteUuid
        createdAt
      }
      nextCursor
    }
  }
`;

export default ORGANIZATION_RECORDING_CONSENT_EVENTS;
